import { getEnumValues } from './get-enum-values';

export enum PurchaseStep {
    Prepare='prepare',
    Information='info',
    Agreements='agreements',
    Review='review',
    Purchase='purchase',
}

export const PurchaseStepValues = getEnumValues<PurchaseStep>(PurchaseStep);
